/* JB | carrinho: complete seu frete grátis + cupom aplicado no carrinho + brindes recolhidos e com link */
(function () {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function refreshCart() {
    const evt =
      typeof _EVENT_HELPER !== 'undefined' && _EVENT_HELPER.updateAndShowCart
        ? _EVENT_HELPER.updateAndShowCart
        : null;
    if (evt) {
      document.dispatchEvent(new CustomEvent(evt, { detail: {} }));
    } else {
      window.location.reload();
    }
  }

  /* ---------- cards de brinde (app de brindes) levam para a coleção da promoção ---------- */
  const BRINDE_LINKS = [
    { match: /centella/i, url: '/collections/centella-madascar?sort_by=manual' },
    { match: /mother\s*fluffer/i, url: '/collections/lancamento-banner?sort_by=manual' },
  ];
  const BRINDE_CARD = '.gfgFreeGiftMsgParentContainerForDropDown';

  function linkDoBrinde(card) {
    const texto = card.innerText || card.textContent || '';
    const regra = BRINDE_LINKS.find((l) => l.match.test(texto));
    return regra ? regra.url : null;
  }

  function marcarBrindes() {
    document.querySelectorAll(BRINDE_CARD).forEach((card) => {
      if (card.dataset.jbLink) return;
      const url = linkDoBrinde(card);
      if (!url) return;
      card.dataset.jbLink = url;
      card.classList.add('jb-brinde-link');
      card.setAttribute('role', 'link');
      card.tabIndex = 0;
    });
  }

  function abrirBrinde(e) {
    const card = e.target && e.target.closest && e.target.closest(BRINDE_CARD);
    if (!card) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    const url = card.dataset.jbLink || linkDoBrinde(card);
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }

  /* ---------- brindes do carrinho recolhidos numa linha fina (toque para ver) ---------- */
  let brindesAbertos = false;

  function textoToggle(qtd) {
    const rotulo = qtd === 1 ? '1 brinde disponível' : qtd + ' brindes disponíveis';
    return `<span class="jb-brindes-toggle__txt">\u{1F381} ${rotulo}</span><span class="jb-brindes-toggle__acao">${brindesAbertos ? 'ocultar' : 'ver'}</span>`;
  }

  function montarToggleBrindes() {
    document.querySelectorAll('.drawer__body > .gfgFreeGiftSideCartWrapperV4').forEach((wrap) => {
      const qtd = wrap.querySelectorAll(BRINDE_CARD).length;
      let toggle = wrap.previousElementSibling;
      if (!toggle || !toggle.classList.contains('jb-brindes-toggle')) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'jb-brindes-toggle';
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          brindesAbertos = !brindesAbertos;
          montarToggleBrindes();
        });
        wrap.parentElement.insertBefore(toggle, wrap);
      }
      toggle.hidden = qtd === 0;
      const html = textoToggle(qtd);
      if (toggle.innerHTML !== html) toggle.innerHTML = html;
      toggle.setAttribute('aria-expanded', brindesAbertos ? 'true' : 'false');
      wrap.classList.toggle('jb-brindes-recolhido', !brindesAbertos);
    });
  }

  if (!window.__jbBrindeLinks) {
    window.__jbBrindeLinks = true;
    document.addEventListener('click', abrirBrinde, true);
    document.addEventListener('keydown', abrirBrinde, true);
    let agendado = false;
    const observar = () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => {
        agendado = false;
        marcarBrindes();
        montarToggleBrindes();
      });
    };
    const iniciar = () => {
      marcarBrindes();
      montarToggleBrindes();
      new MutationObserver(observar).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) iniciar();
    else document.addEventListener('DOMContentLoaded', iniciar);
  }

  /* ---------- complete seu frete: cards no formato dos brindes ---------- */
  // Estado guardado entre um redesenho e outro do carrinho, para a lista não fechar ao adicionar.
  const estado = { aberto: null, scroll: 0, ultimo: null };

  if (!customElements.get('jb-complete-frete')) {
    class JbCompleteFrete extends HTMLElement {
      connectedCallback() {
        // Renderizado dentro da faixa de frete; vai para logo abaixo dela.
        const align = this.closest('.cart__free__shipping__alignment');
        if (align) {
          align.after(this);
          return; // o after() reconecta o elemento e roda o connectedCallback de novo
        }
        this.restaurar();
        if (this._bound) return;
        this._bound = true;

        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-jb-cf-fechar]')) {
            e.preventDefault();
            this.fecharPaineis();
            estado.aberto = null;
            return;
          }

          const abrir = e.target.closest('[data-jb-cf-open]');
          if (abrir) {
            e.preventDefault();
            const id = abrir.dataset.jbCfOpen;
            const painel = this.querySelector(`[data-jb-cf-cores="${id}"]`);
            const jaAberto = painel && !painel.hidden;
            this.fecharPaineis();
            estado.aberto = null;
            if (painel && !jaAberto) {
              painel.hidden = false;
              abrir.setAttribute('aria-expanded', 'true');
              estado.aberto = id;
            }
            return;
          }

          const add = e.target.closest('[data-jb-cf-variant]');
          if (add) {
            e.preventDefault();
            this.add(add, add.dataset.jbCfVariant);
          }
        });

        const track = this.querySelector('.jb-cf__track');
        if (track) {
          track.addEventListener('scroll', () => { estado.scroll = track.scrollLeft; }, { passive: true });
        }
      }

      restaurar() {
        const track = this.querySelector('.jb-cf__track');
        if (track && estado.scroll) track.scrollLeft = estado.scroll;
        if (estado.aberto) {
          const painel = this.querySelector(`[data-jb-cf-cores="${estado.aberto}"]`);
          const botao = this.querySelector(`[data-jb-cf-open="${estado.aberto}"]`);
          if (painel && botao) {
            painel.hidden = false;
            botao.setAttribute('aria-expanded', 'true');
          } else {
            estado.aberto = null;
          }
        }
        if (estado.ultimo) {
          this.querySelectorAll(`[data-jb-cf-variant="${estado.ultimo}"]`).forEach((el) => el.classList.add('is-added'));
        }
      }

      fecharPaineis() {
        this.querySelectorAll('[data-jb-cf-cores]').forEach((p) => (p.hidden = true));
        this.querySelectorAll('[data-jb-cf-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }

      async add(btn, variantId) {
        if (btn.disabled) return;
        const erro = this.querySelector('[data-jb-cf-erro]');
        if (erro) erro.hidden = true;
        btn.disabled = true;
        btn.classList.add('is-loading');
        const track = this.querySelector('.jb-cf__track');
        if (track) estado.scroll = track.scrollLeft;

        try {
          const res = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers,
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'complete-frete' } }],
            }),
          });
          if (!res.ok) throw new Error('add');
          estado.ultimo = String(variantId);
          refreshCart();
        } catch (_) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (erro) {
            erro.textContent = 'não deu pra adicionar agora. tenta outra cor?';
            erro.hidden = false;
          }
        }
      }
    }
    customElements.define('jb-complete-frete', JbCompleteFrete);
  }

  /* ---------- cupom no rodapé, aplicado no próprio carrinho ---------- */
  if (!customElements.get('jb-cupom-carrinho')) {
    class JbCupomCarrinho extends HTMLElement {
      connectedCallback() {
        // Renderizado dentro da faixa de frete; vai para o topo do rodapé do carrinho.
        const form = this.closest('form');
        const footer = form && form.querySelector('.drawer__action__btn');
        if (footer && this.parentElement !== footer) {
          footer.prepend(this);
          return;
        }
        if (this._bound) return;
        this._bound = true;

        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-jb-cupom-aplicar]');
          if (!btn) return;
          e.preventDefault();
          this.aplicar(btn);
        });
      }

      async aplicar(btn) {
        if (btn.disabled) return;
        const code = this.dataset.code || '';
        const upper = code.toUpperCase();
        const erro = this.querySelector('[data-jb-cupom-erro]');
        if (erro) erro.hidden = true;
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'aplicando...';

        let existentes = [];
        try {
          const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          existentes = (cart.discount_codes || [])
            .filter((d) => d && d.code && d.applicable !== false)
            .map((d) => d.code)
            .filter((c) => c.toUpperCase() !== upper);

          const res = await fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers,
            body: JSON.stringify({ discount: [code, ...existentes].join(',') }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error('rede');

          const aceito = (data.discount_codes || []).some(
            (d) => String(d.code || '').toUpperCase() === upper && d.applicable !== false
          );
          if (!aceito) {
            await fetch(root() + 'cart/update.js', {
              method: 'POST',
              headers,
              body: JSON.stringify({ discount: existentes.join(',') }),
            });
            throw new Error('invalido');
          }
          refreshCart();
        } catch (err) {
          btn.disabled = false;
          btn.textContent = label;
          if (erro) {
            erro.textContent =
              err && err.message === 'invalido'
                ? 'esse cupom não vale pra esse carrinho.'
                : 'não deu pra aplicar agora. tenta de novo?';
            erro.hidden = false;
          }
        }
      }
    }
    customElements.define('jb-cupom-carrinho', JbCupomCarrinho);
  }
})();
